module.exports = __webpack_public_path__ + "static/media/magic-stick.3526e976.svg";